import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FooterProps } from '../components/Footer/components/Footer';

type Props = {
  children: React.ReactNode;
  footerProps?: Pick<FooterProps, 'withMarginTop'>
}

function ErrorLayout({
  children
}: Props) {
  return (
    <>
      <Header />
      {children}
      <Footer withMarginTop={false} withBackgroundColor={true} />
    </>
  );
}

export default ErrorLayout;
